// import Vue from 'vue'
import ably from '../../core/ably'
import StoreInit from '../../api/initialise_store'
import doctor from '../../api/doctor'

// State
const state = {
  role: null,
  availableForChat: JSON.parse(sessionStorage.getItem('availableForChat')),
  connectivityStatus: 'not_connected', // connecting & connected are others
  enableChat: true, // For non sponsor doctors
  doctorId: null,
  phrases: [],
  isCompanyDoctor: null,
  ablyKey: null,
  name: null,
  id: null,
  profileDetails: {},
  companyId: null,
  prescriptionFlag: null,
  chatStatus: null,
  activeAdminMiniMenu: 'DoctorMain',
  activeMiniMenu: 'Chat',
  onlineActiveSection: 'connected',
  offlineActiveSection: 'connected',
  activeRightPaneTab: 'consultation-summary'
}

// Getters
const getters = {
  getRole () {
    return state.role
  },

  isChatEnabled () {
    return state.enableChat
  },

  doctor () {
    return state.profileDetails
  },

  getActiveSection (state, getters, rootState) {
    if (state.activeMiniMenu === 'Chat') {
      return state.onlineActiveSection
    } else if (state.activeMiniMenu === 'OfflineConsults') {
      return state.offlineActiveSection
    }
  },

  getActiveRightPaneTab: function () {
    return state.activeRightPaneTab
  },

  getActiveMiniMenu (state) {
    return state.activeMiniMenu
  },

  getActivePatientProfile (state, getters, rootState) {
    let consult = null
    if (state.activeMiniMenu === 'Chat') {
      if (state.onlineActiveSection === 'connected' && rootState.consultation.activeChannelId !== null) {
        consult = rootState.consultation.activeConsults.find(function (ele) {
          return (ele.channelId === rootState.consultation.activeChannelId)
        })
      } else if (state.onlineActiveSection === 'consults' && rootState.pastConsultation.activePastConsultationRequestId !== null) {
        consult = rootState.pastConsultation.pastConsults.find(function (ele) {
          return (ele.consultationRequest.consultationRequestId === rootState.pastConsultation.activePastConsultationRequestId)
        })
      }
    } else if (state.activeMiniMenu === 'OfflineConsults') {
      if (state.offlineActiveSection === 'connected' && rootState.offlineConsultation.activeCustomerId !== null) {
        consult = rootState.offlineConsultation.activeOfflineConsults.find(function (ele) {
          return (ele.channelId === rootState.offlineConsultation.activeCustomerId)
        })
      } else if (state.offlineActiveSection === 'consults' && rootState.pastOfflineConsultation.activePastConsultId !== null) {
        consult = rootState.pastOfflineConsultation.pastOfflineConsults.find(function (ele) {
          return (ele.consultation.consultationId === rootState.pastOfflineConsultation.activePastConsultId)
        })
      }
    }
    if (consult) {
      return consult
    }
  },
  customerNotifications (state, getters, rootState) {
    let activeCustomer = getters.getActivePatientProfile
    if (activeCustomer && activeCustomer.details && activeCustomer.details.notifications && activeCustomer.details.notifications.length > 0) {
      return activeCustomer.details.notifications
    }
    return []
  }
}

// Actions
const actions = {
  init ({commit, state, dispatch}) {
    StoreInit.fetchConfigurations().then(response => {
      if (response.status === 200) {
        commit('setUpDoctor', response.body.doctor)
        if (!state.isCompanyDoctor && state.role !== 'admin') {
          dispatch('establishAblyConnection') // init online consultations
          dispatch('pastConsultation/init', {}, { root: true }) // init past cosultations
          dispatch('consultationRequest/setUpQueries', {}, { root: true }) // init past cosultations
        } else if (state.isCompanyDoctor) {
          dispatch('setActiveMiniMenu', 'OfflineConsults')
        } else if (state.role === 'admin') {
          // basically for past consults
          commit('updateOnlineActiveSection', 'consults')
        }
        dispatch('notification/init', {}, { root: true }) // init notifications
        dispatch('preFilledMedications/init', {}, { root: true })
      }
    })
  },

  establishAblyConnection ({commit, state}) {
    ably.init(state.doctorId, state.ablyKey)
    commit('setConnectivity', 'connecting')
  },

  ablyConnected ({ commit, state, dispatch }) {
    commit('setConnectivity', 'connected')
    ably.subscribeToChannel(`${state.doctorId}_communication`)
    if (state.availableForChat === true) {
      ably.subscribeToChannel('doctors_channel')
      ably.subscribeToChannel(state.doctorId)
      // init consult requests
      StoreInit.fetchConsultationRequestsDetails().then(response => {
        if (response.status === 200) {
          dispatch('consultationRequest/init', { details: response.body.consultation_requests }, { root: true })
        }
      })
    }
    // init ongoing consultations
    dispatch('consultation/init', {}, { root: true })
  },

  ablyDisconnected ({ commit, state }) {
    commit('setConnectivity', 'disconnected')
  },

  ablySuspended ({ commit, state }) {
    commit('setConnectivity', 'suspended')
  },

  ablyFailed ({ commit, state }) {
    commit('setConnectivity', 'failed')
  },

  setChatAvailability ({commit, state, dispatch}, status) {
    sessionStorage.setItem('availableForChat', status)
    commit('updateAvailableForChat', status)
    if (status === true) {
      ably.subscribeToChannel('doctors_channel')
      ably.subscribeToChannel(state.doctorId)
      StoreInit.fetchConsultationRequestsDetails().then(response => {
        if (response.status === 200) {
          dispatch('consultationRequest/init', { details: response.body.consultation_requests }, { root: true })
        }
      })
    } else {
      ably.updatePresenceEvents('doctors_channel', 'leave')
      ably.updatePresenceEvents(state.doctorId, 'leave')
    }
  },

  setOnlineActiveSection ({commit, state, rootState, dispatch}, section) {
    commit('updateOnlineActiveSection', section)
    if (rootState.pastConsultation.initiated) {
      if (section === 'consults' && !rootState.pastConsultation.activePastConsultationRequestId && rootState.pastConsultation.pastConsults.length > 0) {
        dispatch('pastConsultation/switchTo',
          {
            id: rootState.pastConsultation.pastConsults[0].consultation.consultationId,
            consultationRequestId: rootState.pastConsultation.pastConsults[0].consultationRequest.consultationRequestId
          }, {root: true})
      }
    }
  },

  setOfflineActiveSection ({commit, state, rootState, dispatch}, section) {
    commit('updateOfflineActiveSection', section)
    if (rootState.pastOfflineConsultation.initiated) {
      if (section === 'consults' && !rootState.pastOfflineConsultation.activePastConsultId && rootState.pastOfflineConsultation.pastOfflineConsults.length > 0) {
        dispatch('pastOfflineConsultation/switchTo', rootState.pastOfflineConsultation.pastOfflineConsults[0].consultation.consultationId, {root: true})
      }
    }
  },

  setRightPaneTab ({commit}, tab) {
    commit('updateRightPaneTab', tab)
  },

  setActiveMiniMenu ({commit, state, rootState, dispatch}, menu) {
    commit('updateActiveMiniMenu', menu)
    if (menu === 'OfflineConsults' && !rootState.offlineConsultation.initiated) {
      dispatch('offlineConsultation/init', {}, { root: true })
      dispatch('pastOfflineConsultation/init', {}, { root: true })
    } else if (menu === 'PreEmpAppointmentRequests' && !rootState.appointmentRequest.initiated) {
      dispatch('preEmpAppointmentRequest/setPreEmpAppointments', {status: 'scheduled', page: 1}, {root: true})
    }
  },

  setActiveAdminMiniMenu ({commit, state, rootState, dispatch}, menu) {
    commit('updateActiveAdminMiniMenu', menu)
  },

  updateDoctorAttribute ({commit}, payload) {
    commit('updateDoctorAttribute', payload)
  },

  saveDoctorDetails ({state, commit, dispatch}, {signature, profile}) {
    var data = new FormData()
    data.append('name', state.profileDetails.name)
    data.append('qualification', state.profileDetails.qualification)
    data.append('description', state.profileDetails.description)
    data.append('mobile_number', state.profileDetails.mobile_number)
    data.append('registration_number', state.profileDetails.registration_number)
    if (signature !== null) {
      data.append('signature', signature, signature.name)
    }
    if (profile !== null) {
      data.append('photo', profile, profile.name)
    }
    doctor.updateDoctorDetails(data).then(response => {
      if (response.status === 200) {
        commit('updateDoctor', response.body.doctor)
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },
  updateReadNotification ({commit, getters, dispatch}, id) {
    let activeCustomer = getters.getActivePatientProfile
    doctor.updateRead(id).then(response => {
      if (response.status === 200) {
        commit('updateReadNotification', {id: id, activeCustomer: activeCustomer})
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },
  updateViewedNotification ({commit, getters, dispatch}) {
    let activeCustomer = getters.getActivePatientProfile
    let nId = activeCustomer.details.notifications[0] && activeCustomer.details.notifications[0].id ? activeCustomer.details.notifications[0].id : null
    if (nId) {
      doctor.customerUpdateViewed(nId).then(response => {
        if (response.status === 200) {
          commit('updateViewedNotification', {activeCustomer: activeCustomer})
        }
      })
    }
  }
}

// Mutations
const mutations = {
  turOnVisibility () {
  },
  turnOffVisibility () {
  },
  addRole (role) {
  },
  setConnectivity (state, status) {
    state.connectivityStatus = status
  },
  setUpDoctor (state, doctor) {
    let externalAdmin = !doctor.profiledetails.internal_doctor && doctor.role === 'admin'
    let specialistDoctor = !doctor.profiledetails.internal_doctor && doctor.role.toLowerCase() === 'specialist'
    let newRole = externalAdmin ? 'externalAdmin' : specialistDoctor ? 'specialistDoctor' : doctor.role
    console.log('Role - ', newRole)
    state.doctorId = doctor.doctor_id
    state.name = doctor.name
    state.id = doctor.did
    state.chatStatus = doctor.chatstatus
    state.profileDetails = doctor.profiledetails
    state.role = newRole
    state.companyId = doctor.company_id
    state.prescriptionFlag = doctor.prescription_flag
    state.isCompanyDoctor = doctor.is_company_doctor
    state.ablyKey = doctor.ably_token
    state.phrases = doctor.phrases
  },
  updateAvailableForChat (state, status) {
    state.availableForChat = status
  },
  updateOnlineActiveSection (state, section) {
    state.onlineActiveSection = section
  },
  updateOfflineActiveSection (state, section) {
    state.offlineActiveSection = section
  },
  updateActiveMiniMenu (state, menu) {
    state.activeMiniMenu = menu
  },
  updateActiveAdminMiniMenu (state, menu) {
    state.activeAdminMiniMenu = menu
  },
  updateDoctor (state, data) {
    let signature = data.signature
    let photo = data.photo
    data.photo = {url: photo}
    data.signature = {url: signature}
    state.profileDetails = data
  },
  updateDoctorAttribute (state, data) {
    let profileDetails = state.profileDetails
    state.profileDetails = Object.assign(profileDetails, data)
  },
  updateRightPaneTab (state, tab) {
    state.activeRightPaneTab = tab
  },
  updateReadNotification (state, {id, activeCustomer}) {
    if (activeCustomer && activeCustomer.details && activeCustomer.details.notifications && activeCustomer.details.notifications.length > 0) {
      let n = activeCustomer.details.notifications.find(function (c) {
        if (c.id === id) return c
      })
      if (n) {
        let i = activeCustomer.details.notifications.indexOf(n)
        activeCustomer.details.notifications[i].is_read = true
      }
    }
  },
  updateViewedNotification (state, {activeCustomer}) {
    if (activeCustomer && activeCustomer.details && activeCustomer.details.notifications && activeCustomer.details.notifications.length > 0) {
      activeCustomer.details.notifications.map(function (n) {
        n.is_viewed = true
      })
    }
  },
  reset (state) {
    state = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/configuration.js